<div class="standard-page">
  <ng-content></ng-content>
</div>
